// Import jQuery => utilise celui de wp de base, evite duplicat de jquery
import jQuery from "jquery";
// export for others scripts to use
window.$ = window.jQuery = jQuery;

// Require modules
import browserClassHelpers from './modules/browser-class-helpers.js';
import header from './modules/header.js';
import collapseOnScroll from './modules/header-collapseOnScroll.js';
import materialForm from './modules/material-form.js';
import popin from './modules/popin.js';
import scrollAnchor from './modules/scroll-anchor.js';
// import ssTooltip from './modules/tooltip';
import shareLinks from './modules/shareLinks';

// import checkVisible from './modules/checkVisible';
import animateOnView from './modules/animate-on-view';

import scenoSlider from './modules/scenoSlider';
import productSlider from './modules/productSlider';
// import tabList from './modules/tabList';
import tabListSplide from './modules/tabListSplide';
import productCalculator from "./modules/product-calculator";
import productMain from "./modules/productMain";
import popinProductPreview from "./modules/popinProductPreview";
import zoomImage from "./modules/zoomImage";
import videoPlayer from "./modules/videoPlayer";
import resultList from "./modules/resultList";
import autoResizeInput from "./modules/autoResizeInput";
import wishlist from "./modules/wishlist";
import glossarySearch from "./modules/glossarySearch";
import contactForm from "./modules/contactForm";
import storeLocator from "./modules/storeLocator";
import drawer from "./modules/drawer";
import sampleCart from "./modules/sampleCart";
import sampleDrawer from "./modules/sampleDrawer";
import inputFile from "./modules/inputFile";
import quoteRequest from "./modules/quoteRequest";
import projectPicture from "./modules/projectPicture";
import replenishmentCustomer from "./modules/replenishment_customer";
import replenishmentShowroom from "./modules/replenishment_showroom";
import plyr from "./modules/plyr";

// import 'slick-carousel';

$(function(){
	$("html").removeClass("no-js");

	browserClassHelpers.init();
	
	header.init();
	collapseOnScroll.init();

	shareLinks.init();
	inputFile.init();

	
	if ($(".js-autoResizeInput").length) {
		autoResizeInput.init();
	}
	
	if ($(".js-materialForm").length) {
		materialForm.init();
	}
	if ($(".js-product-calculator").length) {
		productCalculator.init();
	}
	if ($(".js-videoPlayer").length) {
		$(".js-videoPlayer").each(function(){
			let player = new videoPlayer($(this)[0]);
		});
	}
	if ($(".js-productMain").length) {
		productMain.init();
	}
	if ($(".js-popinProductPreview").length) {
		popinProductPreview.init();
	}
	if ($(".js-zoomImage").length) {
		zoomImage.init();
	}
	if ($(".js-scroll-anchor").length) {
		scrollAnchor.init();
	}
	if ($(".js-scenoSlider").length) {
		scenoSlider.init();
	}
	if ($(".js-productSlider").length) {
		productSlider.init();
	}
	if ($(".js-resultList-form").length) {
		resultList.init();
	}
	if($(".js-quote-request-form").length) {
		quoteRequest.init();
	}
	if($(".js-project-picture").length) {
		projectPicture.init();
	}
	if($(".js-replenishment-company-form").length) {
		replenishmentCustomer.init();
	}
	if($(".js-replenishment-showroom-form").length) {
		replenishmentShowroom.init();
	}
	
	// if ($(".js-tabList").length) {
	// 	// utilisé dans les pages ajax search resultList.js (pour reinit après la recherche qui remplace le html)
	// 	$(".js-tabList").each(function(){
	// 		let tab = new tabList();
	// 		tab.init($(this));
	// 	});
	// }
	if ($(".js-tabListSplide").length) {
		// utilisé dans les pages ajax search resultList.js (pour reinit après la recherche qui remplace le html)
		$(".js-tabListSplide").each(function(){
			let tab = new tabListSplide();
			tab.init($(this));
		});
	}
	if ($(".js-popin").length) {
		popin.init();
	}
	if ($(".js-drawer").length) {
		drawer.init();
	}
	sampleCart.init();
	// if ($(".js-wishlist-edit").length) {
		wishlist.init();
	// }
	// if ($('.js-tooltip').length) {
	// 	ssTooltip.init();
	// }
	if ($(".js-sample-drawer").length) {
		sampleDrawer.init();
	}
		

	if ($('.js-animate-on-view').length) {
		animateOnView.init();
	}

	$("body").on("click", ".js-toggleSlide", function(){
		var $this = $(this);
		var $target = $($this.attr("data-target"));
		$target.slideToggle(250);
		$this.toggleClass("active");
	});

	// <div class="dropdownButton js-dropdownButton">
	// 		<button type="button" class="dropdownButton__btn js-dropdownButton__btn">
	// 			{{ "product_list.relevance"|trans }}
	// 			<svg class="icon icon-carret-bot" aria-hidden="true"><use xlink:href="#icon-carret-bot"></use></svg>
	// 		</button>
	// 		<div class="dropdownButton__content js-dropdownButton__content">
	// 			<div class="dropdownButton__item">
	// 				<a href="?relevance=new" class="dropdownButton__link">{{ "product_list.relevance.new"|trans }}</a>
	// 			</div>
	// 			<div class="dropdownButton__item">
	// 				<a href="?relevance=a_z" class="dropdownButton__link">{{ "product_list.relevance.a_z"|trans }}</a>
	//			</div>
	// 			<div class="dropdownButton__item">
	// 				<a href="?relevance=z_a" class="dropdownButton__link">{{ "product_list.relevance.z_a"|trans }}</a>
	//			</div>
	// 		</div>
	// </div>
	$("body").on("click", ".js-dropdownButton__btn", function(){
    	$(this).closest(".js-dropdownButton").toggleClass("open");
    });
    $("body").on("click", ".js-dropdownButton__link", function(){
    	$(this).closest(".js-dropdownButton").find("js-dropdownButton__btn-text").text($(this).text());
    });

    $("body").on("click", ".js-change-item-per-line", function(){
    	let $this = $(this);
    	let $target = $($this.attr("data-item-per-line-target"));
    	let number = $this.attr("data-item-per-line-number");
    	$target.attr("data-item-per-line", number);
    	$(".js-change-item-per-line").removeClass("active");
    	$this.addClass("active");
    });

    $(".js-faq").each(function(){
    	let $this = $(this);
		let $details = $this.find(".js-faq-details");
		let $summary = $this.find(".js-faq-summary");
		let $img = $this.find(".js-faq-img");
		$summary.on("click", function(){
			$details.removeAttr("open");
			$(this).attr("open",true);
			let imgSrc = $(this).attr("data-image");
			if(imgSrc == '' || imgSrc == undefined){
				imgSrc = $summary.eq(0).attr("data-image");
			}
			$img.attr("src", imgSrc);
		});
	});

	$(".js-lexique").each(function(){
    	let $this = $(this);
		let $details = $this.find(".js-lexique-details");
		let $summary = $this.find(".js-lexique-summary");
		let $img = $this.find(".js-lexique-img");
		$summary.on("click", function(){
			$details.removeAttr("open");
			$(this).attr("open",true);
			let imgSrc = $(this).attr("data-image");
			if(imgSrc == '' || imgSrc == undefined){
				imgSrc = $summary.eq(0).attr("data-image");
			}
			$img.attr("src", imgSrc);
		});
	});

	// show/hide password text
		let $toggleShowPassword = $(".js-passwordBlock-toggleShow");
		$toggleShowPassword.on('click', function(){
			let $this = $(this);
			let $passwordBlock = $this.closest(".js-passwordBlock");
			let $passwordInput  = $passwordBlock.find(".js-passwordBlock-input");
			if($this.hasClass("active")){
				$passwordInput.attr("type", "password")
			}else{
				$passwordInput.attr("type", "text")
			}
			$this.toggleClass("active");
		})

	// 
	/* /select schow elem\
		<select class="js-select-trigger-show" data-targets=".js-request-show-on-select">
			<option value=""></option>
			<option value="p1">option show p1</option>
			<option value="p2">option show p2</option>
			<option value="p3">option show p3</option>
		</select>
		<p class="js-hide js-request-show-on-select" data-show-on-select="p1">Hiden p1 until selected option</p>
		<p class="js-hide js-request-show-on-select" data-show-on-select="p2">Hiden p2 until selected option</p>
		<p class="js-hide js-request-show-on-select" data-show-on-select="p3">Hiden p3 until selected option</p>
	*/
		$(".js-select-trigger-show").on("change", function(){
			let $thisSelect = $(this);
			let $targets = $($thisSelect.attr("data-targets"));
			let $targetsNoresults = $($thisSelect.attr("data-targets-noresult"));
			let $target = $targets.filter("[data-show-on-select='"+$thisSelect.val()+"']");
			console.log($thisSelect.attr("data-targets-noresult"));
			console.log($targetsNoresults);
			if($thisSelect.val() == ''){
				$targets.addClass("js-hide");
				$targetsNoresults.addClass("js-hide");
			}else{
				$targets.addClass("js-hide");
				$target.removeClass("js-hide");
				if($targets.not('.js-hide').length == 0){
					$targetsNoresults.removeClass("js-hide");
				}else{
					$targetsNoresults.addClass("js-hide");
				}
			}

		});
		$(".js-select-trigger-show").change();

	// radio show elem
		$(".js-radio-trigger-show").on("change", function(){
			let $thisRadio = $(this);
			let $targets = $($thisRadio.attr("data-targets"));
			let $target = $targets.filter("[data-show-on-radio='"+$thisRadio.val()+"']");
			$targets.addClass("js-hide");
			$targets.each(function(){
				$(this).find('input').prop("required", false)
			});
			if($thisRadio.prop('checked')){
				$target.removeClass("js-hide");
				if($target.find('input').attr('data-required') == 'true'){
					$target.find('input').prop("required", true)
				}
				if($thisRadio.val() == "all"){
					$targets.each(function(){
						$targets.removeClass("js-hide");
					});
				}
			}
		});
		$(".js-radio-trigger-show:checked").change();

	// hash scroll
	if(window.location.hash){
		setTimeout(function(){ // delay to fix jankyness
			let hashTarget = document.querySelector(window.location.hash);
			if(hashTarget){
				document.querySelector("html").scrollTo({
					top: hashTarget.offsetTop - (20 + document.querySelector(".js-menu-nav").offsetHeight),
					behavior: 'smooth'
				});
				if(hashTarget.classList.contains("js-faq-details")){
					hashTarget.setAttribute("open", "")
				}
			}
		},500);
	}

	// js-addActiveClassOnBottomScroll
	window.checkScrolledBottom = function(){
		var $this = $(this);
		var currentScrollPos = $this.scrollTop() + $this.innerHeight();
		console.log(currentScrollPos);
		console.log($this[0].scrollHeight);
		if(currentScrollPos >= $this[0].scrollHeight){
			$this.addClass("scrolledBottom");
		}else{
			$this.removeClass("scrolledBottom");			
		}
	}
	$(".js-addScrolledBottomClassOnBottomScroll").on("scroll", checkScrolledBottom);

	if ($(".js-search-glossary").length) {
		glossarySearch.init();
	}

	if ($('.js-contactForm').length) {
		contactForm.init();
	}
	if ($('.js-requestQuoteForm').length) {
		requestQuoteForm.init();
	}
	if ($('.js-storeLocator').length) {
		storeLocator.init();
	}

	$(".js-submitOnChange input").on('change', function(){
		$(this).closest(".js-submitOnChange").submit();
	});

	// scroll bar width for disable-scroll class ("Le menu se décale légèrement de droite à gauche lorsqu'on interagit avec le menu")
		function getScrollBarWidth() {
			let el = document.createElement("div");
			el.style.cssText = "overflow:scroll; visibility:hidden; position:absolute;";
			document.body.appendChild(el);
			let width = el.offsetWidth - el.clientWidth;
			el.remove();
			return width;
		}
		window.scrollBarWidth = getScrollBarWidth();
		document.documentElement.style.setProperty('--scrollbarWidth', window.scrollBarWidth+"px");

	let lockScrollInvalidForm = false;
	$("form *").on('invalid', function(){
		if(!lockScrollInvalidForm){
			lockScrollInvalidForm = true;
			$("html, body").addClass('submitingForm');
			setTimeout(()=>{
				let scrollDest = $("html,body").scrollTop() - ($(".js-menu-nav").outerHeight(true) + 50);
				$("html,body").scrollTop(scrollDest);
			},50);
			setTimeout(()=>{
				lockScrollInvalidForm = false;
				$("html,body").removeClass('submitingForm');
			},250);
		}

	});

	if($(".js-plyr").length > 0){
		plyr.init();
	} 
});